module.exports = __webpack_public_path__ + "media/fonts/UHC_Sans/UHCSans-Bold-d0b9c4bac3fcf3f67550af3231d1418b.woff";